import { COLORS, URLS } from '@/constants/calculator';

const HERO_BG_STYLE = {
  backgroundImage: `url(${URLS.HERO_IMAGE})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

const PURPLE_TINT_STYLE = { backgroundColor: COLORS.PURPLE_OVERLAY };

export const HeroSection = () => (
  <div className="relative bg-slate-900 overflow-hidden">
    <div className="absolute inset-0 z-0" style={HERO_BG_STYLE}>
      <div className="absolute inset-0 bg-black/50" style={PURPLE_TINT_STYLE}></div>
      <div className="absolute inset-0 bg-black/50"></div>
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <img
        src={URLS.ARLO_LOGO}
        alt="ARLO Express Sheetmetals"
        className="h-12 mb-8"
        data-testid="arlo-logo"
      />
      <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-black text-white mb-4">
        Ducting Installation - Labour Cost Calculator
      </h1>
      <p className="text-lg text-slate-300 max-w-2xl">
        Understand the true difference between self delivery and fully managed ducting installation models
      </p>
    </div>
  </div>
);
